(function () {
	'use strict';

	a3_cabin_reports.factory('FlightDelaysFactory', FlightDelaysFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name FlightDelaysFactory
    * @description 
    *   Add, Update, Delete and Get FlightDelays.
    * @ngInject
    */
	function FlightDelaysFactory(GenericService) {

		var objType = 'FlightDelays';
		var objCallback = FlightDelays;

        /**
         * Initialize the FlightDelays
         * @memberof FlightDelaysFactory
         */
		function FlightDelays() {
			this.GetId = GetId;
		}

		var service = {
			getFlightDelaysFromStorage: getFlightDelaysFromStorage,
			setFlightDelaysToStorage: setFlightDelaysToStorage,
			getFlightDelaysByFlightId: getFlightDelaysByFlightId,
			addFlightDelays: addFlightDelays,
			upsertFlightDelays: upsertFlightDelays,
			cleanOldFlightDelays: cleanOldFlightDelays
		};

		//Object Functions
        /**
         * Overide default get Id
         * @memberof FlightFactory
         * @returns {number} Id 
         */
		function GetId() {
			return this.FlightId;
		}

		/**
	   * Get FlightDelays
	   * @memberof FlightDelaysFactory
	   * @param {function} callback  
	   */
		function getFlightDelaysFromStorage() {
			return GenericService.list(objType, objCallback);
		};

        /**
        * Save FlightDelays to storage
        * @memberof FlightDelaysFactory
        * @param {Array} FlightDelays A list of FlightDelays
        */
		function setFlightDelaysToStorage(flightDelays) {
			GenericService.saveAll(flightDelays,objType,objCallback);
		}
    
		/**
		* Get single flight FlightDelays
		* @memberof FlightDelaysFactory
		* @param {function} callback  
		*/
		function getFlightDelaysByFlightId(flightId) {
			return GenericService.get(flightId, objType, objCallback);
		};

		/**
		* Set single flight FlightDelays
		* @memberof FlightDelaysFactory
		* @param {function} callback  
		*/
		function addFlightDelays(FlightDelays) {
			return GenericService.add(FlightDelays, objType, objCallback);
		};



        /**
        *  Upsert Flight Delays
        * @memberof FlightDelaysFactory
        */
		 function upsertFlightDelays(newflightDelays) {
            var newFLightIds = newflightDelays.map(x => x.FlightId);
            var flightDelaysLS = this.getFlightDelaysFromStorage();
            flightDelaysLS = flightDelaysLS.filter(x => !newFLightIds.includes(x.FlightId));
            var allFlightDelays = flightDelaysLS.concat(newflightDelays);
            setFlightDelaysToStorage(allFlightDelays);
        }

		/**
         * Clean Old Data
         * @memberof FlightDelaysFactory
         * @param {Array} pendingFlightIds FlightIds with pending reports
         */
		function cleanOldFlightDelays(pendingFlightIds) {
			var now = moment();
			getFlightDelaysFromStorage(function(flightDelays){
				var pendingFlightDelays = flightDelays.filter(function(item){
					var date = moment(item.FlightDate);
					return pendingFlightIds.includes(item.FlightId) || now.diff(date, 'days') < 5;
				});
				// keep only the FlightDelays with pending reports
				setFlightDelaysToStorage(pendingFlightDelays);			
			})
		}

		return service;
	}
})();